// pages/Dashboard.jsx
import ReturnPolicy from "../../components/home/policyComponents/ReturnPolicy";
import HomeLayout from "../../components/home/HomeLayout";

export default function Dashboard() {
  return (
    <HomeLayout>
      <ReturnPolicy />
    </HomeLayout>
  );
}
